import { useContext } from 'react'
import { AuthContext } from '../../../Auth/AuthContext'
import ContentHeader from '../../Layout/ContentHeader'

export const Content = () => {
  const { user } = useContext(AuthContext)

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <>
            <div className="col-8">
              <h1 className="header-title">
                Bienvenido{user.name ? `, ${user.name}` : ''}
              </h1>
              {/* <span>
                Aquí tienes un resumen de 10 que está pasando el día de hoy.
              </span> */}
            </div>
          </>
        }
        breadcrumb=""
        windowTitle="Dashboard"
      />
    </>
  )
}

export default Content
